import { useMutation } from '@tanstack/react-query';

import { createEstimateUser } from '@widgets/EstimateInformation/api/createEstimateUser';

export const useCreateEstimateUserQuery = () =>
    useMutation({
        mutationKey: ['createEstimateUser'],
        mutationFn: createEstimateUser,
    });
